module.exports = __webpack_public_path__ + "static/img/products_BioTank.caa3838d.png";